import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { createLead } from "../../lib/chatApi";
import { errorMessage } from "../../lib/api";

const INPUT = "w-full h-9 px-2.5 border border-slate-300 bg-white text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-amber-500";

export const CallbackForm = ({ sessionId, onDone, onClose }) => {
  const [f, setF] = useState({ name: "", phone: "", email: "", question: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.name.trim().length < 2) return setErr("Please enter your name.");
    if (f.phone.replace(/\D/g, "").length < 10) return setErr("Please enter a valid phone number.");
    if (f.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) return setErr("Please enter a valid email or leave it blank.");
    setErr(""); setLoading(true);
    try {
      await createLead({ session_id: sessionId, name: f.name.trim(), phone: f.phone.trim(), email: f.email.trim() || null, question: f.question.trim() });
      onDone(f);
    } catch (e2) {
      setErr(errorMessage(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} noValidate className="border border-amber-300 bg-white p-3.5 space-y-2" data-testid="chat-callback-form">
      <div className="flex items-center justify-between">
        <span className="font-display font-bold uppercase text-slate-900 tracking-wide">Request a callback</span>
        <button type="button" onClick={onClose} aria-label="Close callback form" className="text-slate-500 hover:text-slate-900" data-testid="chat-callback-close"><X className="w-4 h-4" /></button>
      </div>
      <input className={INPUT} placeholder="Name *" value={f.name} onChange={set("name")} data-testid="chat-callback-name" />
      <input className={INPUT} placeholder="Phone *" type="tel" value={f.phone} onChange={set("phone")} data-testid="chat-callback-phone" />
      <input className={INPUT} placeholder="Email (optional)" type="email" value={f.email} onChange={set("email")} data-testid="chat-callback-email" />
      <textarea className={`${INPUT} h-16 py-1.5`} placeholder="Short question (optional)" value={f.question} onChange={set("question")} data-testid="chat-callback-question" />
      {err && <p className="text-xs text-red-700" data-testid="chat-callback-error">{err}</p>}
      <button type="submit" disabled={loading} className="btn-amber h-9 w-full text-xs" data-testid="chat-callback-submit">
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Request callback"}
      </button>
    </form>
  );
};
